import { Accordion, Block } from '@aloft/toolkit-sui';

import { useState } from 'react';
import ReactMarkdown from 'react-markdown';

export const RawTextAccordion = ({ rawText }: { rawText: string }) => {
  const [index, setIndex] = useState<number[]>([]);
  return (
    <Accordion
      panels={[
        {
          id: 'raw-text',
          title: 'Raw model output',
          body: (
            <Block
              maxWidth="1000px"
              overflow="auto"
              __dangerDoNotUseSx={{ wordBreak: 'break-word' }}
            >
              <ReactMarkdown>{rawText}</ReactMarkdown>
            </Block>
          ),
        },
      ]}
      panelState={{ index, onChange: (i) => setIndex(i as number[]) }}
    />
  );
};
